import { Box, Typography } from "@mui/material";
import { useContext, useState } from "react";
import ContainedButton from "../../../../../../components/buttons/ContainedButton";

import { iconsAsset } from "../../../../../stack/environment/icons/iconExport";
import IntegrationImage from "../../../../../stack/integrations/components/IntegrationImage";
import { IntegrationsMapping } from "../../../../../stack/integrations/IntegrationsMapping";
import { notificationMethod } from "../../../../constants";
import { SettingsContext } from "../../../CustomNotificationPage";
import { field_IDs_mapping } from "../../../fieldMapping";
import SettingsSection from "../../components/SettingsSection";
import DriftPercentageMenu from "./DriftPercentageMenu";
import InventoryDriftEmailTextBox from "./InventoryDriftEmailTextBox";

export default function InventoryNotificationsSection() {
  const [fetchStatus, setFetchStatus] = useState(null);
  const notificationSettings = useContext(SettingsContext);

  const emailMethodSettings =
    notificationSettings.settings_by_method[notificationMethod.EMAIL];

  const initialEmail =
    emailMethodSettings[field_IDs_mapping.INVENTORY.ENTITIES_DRIFT].email;

  const initialDriftByTool =
    emailMethodSettings[field_IDs_mapping.INVENTORY.ENTITIES_DRIFT]
      .drift_percentage_by_tool;

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  return (
    <SettingsSection
      title="Inventory Drift"
      Icon={iconsAsset.EntitiesIcon}
      fetchStatus={fetchStatus}
      setFetchStatus={setFetchStatus}
    >
      <Box display="flex" flexDirection="column" gap={2}>
        <InventoryDriftEmailTextBox
          key={initialEmail}
          initialEmail={initialEmail}
          initialDriftByTool={initialDriftByTool}
        />
        <Box display="flex" flexDirection="column" gap={2}>
          {Object.keys(initialDriftByTool).length === 0 ? (
            <Typography variant="caption">
              No integrations currently set for inventory drift notifications
            </Typography>
          ) : (
            <Box width="280px" display="flex" flexDirection="column" gap={1}>
              {Object.entries(initialDriftByTool)
                .filter(([, percentage]) => Boolean(percentage))
                .map(([tool, percentage]) => (
                  <Box
                    key={tool}
                    display="flex"
                    flexDirection="row"
                    gap={1}
                    justifyContent="space-between"
                  >
                    <Box display="flex" flexDirection="row" gap={1}>
                      <IntegrationImage
                        name={tool}
                        width="16px"
                        newLogo={true}
                      />
                      <Typography variant="caption">
                        {IntegrationsMapping[tool].displayName}
                      </Typography>
                    </Box>
                    <Typography variant="caption">{percentage}%</Typography>
                  </Box>
                ))}
            </Box>
          )}
          <ContainedButton
            color="primary"
            size="xs"
            onClick={(event) => {
              setMenuAnchorEl(event.currentTarget);
            }}
          >
            Edit
          </ContainedButton>
        </Box>
      </Box>
      <DriftPercentageMenu
        key={JSON.stringify(initialDriftByTool)}
        menuAnchorEl={menuAnchorEl}
        setMenuAnchorEl={setMenuAnchorEl}
        initialDriftByTool={initialDriftByTool}
        email={initialEmail}
      />
    </SettingsSection>
  );
}
